import { VdsButton, VdsIcon, VdsIconButton } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';

export interface UnlockDialogButtonProps {
  disabled?: boolean;
  isIconButton?: boolean; // If true, render as an icon button instead of a full button.
}

const UnlockDialogButton = ({ isIconButton, disabled = false }: UnlockDialogButtonProps) => {
  const { t } = useTranslation();

  const slot = disabled ? undefined : 'dialog-trigger';

  return isIconButton ? (
    <VdsIconButton slot={slot} icon="lock-closed" disabled={disabled} />
  ) : (
    <VdsButton
      slot={slot}
      variant="secondary"
      size="medium"
      isFullWidth={false}
      disabled={disabled}
    >
      {t('Unlock')}
      <VdsIcon slot="icon-left" svgIcon="lock-closed" />
    </VdsButton>
  );
};

export default UnlockDialogButton;
